import { Box, Text } from 'grommet';
import { FrostedGlassBox } from '../components';

const AddressSection = ({ reportData, addressSelected, colorMap, isMobile }) => {

  return (
    <FrostedGlassBox width={'100%'}>
      <div class="container">
        <Box direction="row" justify="between">
          <Text size="large" margin={{ top: 'small', bottom: 'xsmall', left: '1rem' }}>{addressSelected}</Text>
          {reportData?.cate && (
            <Box
              background={colorMap[reportData?.cate] || '#cccccc'}
              pad={{ horizontal: 'medium', vertical: 'xsmall' }}
              round="xsmall"
              elevation="small"
              align="center"
              justify="center"
              style={{ boxShadow: "none", marginTop: '0.5rem', marginRight: '0.5rem', marginLeft: '1rem', width: 'fit-content', opacity: '0.8' }}
            >
              <Text
                color={reportData?.cate === 'Non-Metro' ? 'black' : 'white'}
                size="small"
                alignSelf='center'
                textAlign='center'
                style={{paddingLeft:'0.5rem',paddingRight:'0.5rem'}}
              >
                {reportData?.cate}{isMobile? '' : ' Postcode'}
              </Text>
            </Box>)}
        </Box>
        <Box margin={{ bottom: '0.49rem' }}></Box>
      </div>
    </FrostedGlassBox>
  );
};

export { AddressSection }